import type { ArticleCategory, ArticleCategoryShallow } from "@brookbush/types";

import type { GetStaticProps } from "next";
import { NextSeo } from "next-seo";

import ArticlesOverview from "./components/ArticlesOverview";
import { GridLayout } from "~/layouts";
import ArticlesCategories from "~/pages/articles/components/ArticlesCategories";
import type { NextPageWithProps } from "~/types";
import fetcher from "~/utils/fetcher.client";

interface ArticlesPageProps {
	categories: Array<ArticleCategory>;
	featuredArticles: ArticleCategory;
	latestArticles: ArticleCategory;
	scholarlyArticles: ArticleCategory;
	shallowCategories: Array<ArticleCategoryShallow>;
}

const ArticlesPage: NextPageWithProps<ArticlesPageProps> = ({
	categories,
	featuredArticles,
	latestArticles,
	scholarlyArticles,
	shallowCategories,
}) => {
	return (
		<>
			<NextSeo title="Articles" description="Brookbush Institute Articles" />
			<GridLayout.Sidebar className="z-20 laptop:block hidden">
				<ArticlesCategories shallowCategories={shallowCategories} />
			</GridLayout.Sidebar>

			<GridLayout.Body>
				<ArticlesOverview
					categories={categories}
					featuredArticles={featuredArticles}
					latestArticles={latestArticles}
					scholarlyArticles={scholarlyArticles}
				/>
			</GridLayout.Body>
		</>
	);
};

ArticlesPage.Layout = GridLayout;

export const getStaticProps: GetStaticProps<{}> = async ({}) => {
	const [categories, latestArticles, shallowCategories] = await Promise.all([
		fetcher("/articles/categories"),
		fetcher("/articles/categories/latest?limit=6"),
		fetcher("/articles/categories/shallow"),
	]);

	const featuredArticles = categories.splice(
		categories.findIndex(
			(category: ArticleCategory) => category.slug === "featured",
		),
		1,
	)[0];

	const scholarlyArticles = categories.splice(
		categories.findIndex(
			(category: ArticleCategory) => category.slug === "scholarly",
		),
		1,
	)[0];

	return {
		props: {
			categories,
			featuredArticles,
			latestArticles,
			scholarlyArticles,
			shallowCategories,
			breadcrumbs: [{ name: "Articles", href: "/articles" }],
		},
	};
};
export default ArticlesPage;
